import React from "react";
import { Checkbox } from "@mui/material";
import styles from "./CompanyRow.module.css";

export default function CompanyRow({ company, checked, onCheck }) {
	const { id, companyName } = company;
	return (
		<div key={id} className={styles.row}>
			<div>
				<Checkbox checked={checked} onChange={() => onCheck(company)} />
				<span>{companyName}</span>
			</div>
			<div />
		</div>
	);
}
